import React from 'react';

import { Stack, StackProps } from '@lyearn/ui';

interface StepperProps extends StackProps {}

const Stepper: React.FC<React.PropsWithChildren<StepperProps>> = ({ children, ...stackProps }) => {
  return <Stack {...stackProps}>{children}</Stack>;
};

export default Stepper;
